<template>
  <div class="permission-settings">
    <div class="settings-title">
      允许查看权限
    </div>
    <div class="settings-group">
      <mk-radio-group
        v-model="params.viewPart"
        :disabled="!params.canEdit"
      >
        <mk-radio :label="false">
          全体
        </mk-radio>
        <mk-radio :label="true">
          指定员工
        </mk-radio>
      </mk-radio-group>
    </div>
    <div
      v-if="params.viewPart"
      class="select-staff"
    >
      <dept-member-select-biz
        v-model="params.dmList"
        :is-mixed="true"
        :can-select-company="false"
        class="select-style"
        width="224"
        :member-api="memberApi"
        :disabled="!params.canEdit"
      />
      <div class="mention">
        侧边栏-智能推荐不受该权限影响
      </div>
    </div>
  </div>
</template>

<script>
import DeptMemberSelectBiz from '@components/dept-member-select-biz'
export default {
  name: 'PermissionSettings',
  components: {
    DeptMemberSelectBiz
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          viewPart: false,
          dmList: {
            dept: [],
            member: []
          }
        }
      }
    }
  },
  data () {
    return {
      viewPart: false,
      memberApi: {
        name: ACCOUNTAPIS.OrganisationApi.v1OrganisationConversationUserListGet,
        params: {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.permission-settings {
  margin-top: 20px;
  padding: 0 16px;

  .settings-title {
    font-size: 13px;
    line-height: 18px;
    color: #595959;
  }

  .settings-group {
    margin-top: 11px;
  }

  .select-staff {
    .select-style {
      margin-top: 11px;
    }

    .mention {
      margin-top: 8px;
      font-size: 12px;
      color: #a1a1a1;
    }
  }
}
</style>
